module.exports = __webpack_public_path__ + "img/FINAL LOGO KURMA (1).d64443b2.jpg";